import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";
import "./InstructorDashboard.css";
import { useNavigate } from "react-router-dom";

function InstructorDashboard({ userData }) {
  const { user, logout } = useAuth();
  const [active, setActive] = useState("overview");
  const [openDropdown, setOpenDropdown] = useState(false);

  const navigate = useNavigate();

const [classTitle, setClassTitle] = useState("");
const [classLink, setClassLink] = useState("");
const [classCourse, setClassCourse] = useState("");
const [publishing, setPublishing] = useState(false);

  const [courses] = useState([
    { id: 1, title: "Full Stack Development", students: 128, status: "Published", progress: 85 },
    { id: 2, title: "React Advanced", students: 74, status: "Draft", progress: 40 },
  ]);

  const [assignments] = useState([
    { id: 1, title: "Build a REST API", course: "Full Stack Development", due: "2026-04-10", submissions: 98 },
    { id: 2, title: "React Hooks Project", course: "React Advanced", due: "2026-04-15", submissions: 45 },
  ]);

  const displayName =
    userData?.name || user?.displayName || user?.name || user?.email || "Instructor";
  const profilePhoto =
    userData?.photoURL || user?.photoURL || userData?.picture || user?.picture || "";
  const getInitials = () =>
    displayName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((n) => n[0])
      .join("")
      .toUpperCase();

  const hasPhoto = Boolean(profilePhoto);

  useEffect(() => {

  if (!user?.email) return;

  if (!user.email.endsWith("@codeion.in")) {

    alert("Only CODEION instructors can access this dashboard");

    navigate("/");

  }

}, [user, navigate]);

const publishClass = async () => {

  try {

    setPublishing(true);

    const { error } = await supabase
      .from("live_classes")
      .insert([
        {
          mentor_email: user?.email,

          mentor_name: displayName,

          class_title: classTitle,

          class_link: classLink,

          course: classCourse,
        },
      ]);

    if (error) {

      alert(error.message);

      return;
    }

    alert("Live class published successfully");

    setClassTitle("");
    setClassLink("");
    setClassCourse("");

  } catch (err) {

    console.error(err);

    alert("Something went wrong");

  } finally {

    setPublishing(false);
  }
};

  const menuItems = [
    { key: "overview", label: "Overview", icon: "🏠" },
    { key: "courses", label: "My Courses", icon: "📚" },
    { key: "content", label: "Upload Content", icon: "📤" },
    { key: "assignments", label: "Assignments", icon: "📝" },
    { key: "students", label: "Students", icon: "👥" },
    { key: "analytics", label: "Analytics", icon: "📊" },
    { key: "profile", label: "Profile", icon: "👤" },
    { key: "liveclass", label: "Live Classes", icon: "🎥" },
  ];

  const renderContent = () => {
    switch (active) {
      case "liveclass":
  return (
    <div>

      <div
        style={{
          background: "#121a32",
          padding: "24px",
          borderRadius: "14px",
        }}
      >

        <h2
          style={{
            marginBottom: "20px",
            color: "white",
          }}
        >
          Create Live Class
        </h2>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >

          <input
            className="id-input"
            placeholder="Class title"
            value={classTitle}
            onChange={(e) =>
              setClassTitle(e.target.value)
            }
          />

          <input
            className="id-input"
            placeholder="Google Meet / Zoom link"
            value={classLink}
            onChange={(e) =>
              setClassLink(e.target.value)
            }
          />

          <input
            className="id-input"
            placeholder="Course name"
            value={classCourse}
            onChange={(e) =>
              setClassCourse(e.target.value)
            }
          />

          <button
            onClick={publishClass}
            style={{
              background: "#f5a623",
              color: "black",
              border: "none",
              padding: "14px",
              borderRadius: "10px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            {publishing
              ? "Publishing..."
              : "Publish Live Class"}
          </button>

        </div>

      </div>

    </div>
  );
      case "overview":
        return (
          <div>
            <div className="id-cards">
              <div className="id-card">
                <div className="id-card-icon">📚</div>
                <div>
                  <h3>Total Courses</h3>
                  <p className="id-card-value">{courses.length}</p>
                </div>
              </div>
              <div className="id-card">
                <div className="id-card-icon">👥</div>
                <div>
                  <h3>Total Students</h3>
                  <p className="id-card-value">{courses.reduce((a, c) => a + c.students, 0)}</p>
                </div>
              </div>
              <div className="id-card">
                <div className="id-card-icon">📝</div>
                <div>
                  <h3>Assignments</h3>
                  <p className="id-card-value">{assignments.length}</p>
                </div>
              </div>
              <div className="id-card">
                <div className="id-card-icon">⭐</div>
                <div>
                  <h3>Avg Rating</h3>
                  <p className="id-card-value">4.8</p>
                </div>
              </div>
            </div>

            <div className="id-section">
              <h3 className="id-section-title">Recent Courses</h3>
              <div className="id-course-list">
                {courses.map((c) => (
                  <div key={c.id} className="id-course-row">
                    <div>
                      <p className="id-course-name">{c.title}</p>
                      <p className="id-course-meta">{c.students} students</p>
                    </div>
                    <span className={`id-badge ${c.status === "Published" ? "id-badge-green" : "id-badge-gray"}`}>
                      {c.status}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="id-section">
              <h3 className="id-section-title">Upcoming Deadlines</h3>
              <div className="id-course-list">
                {assignments.map((a) => (
                  <div key={a.id} className="id-course-row">
                    <div>
                      <p className="id-course-name">{a.title}</p>
                      <p className="id-course-meta">{a.course}</p>
                    </div>
                    <span className="id-due-date">Due: {a.due}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case "profile":
        return (
          <div>
            <h3 style={{ marginBottom: "20px", color: "#b7c0e0", fontSize: "1rem", fontWeight: "600" }}>My Profile</h3>

            <div style={{ background: "#121a32", padding: "24px", borderRadius: "10px", display: "flex", alignItems: "center", gap: "20px", marginBottom: "24px" }}>
              <div>
                {hasPhoto ? (
                  <img src={profilePhoto} alt="profile" referrerPolicy="no-referrer"
                    style={{ width: "70px", height: "70px", borderRadius: "50%", border: "3px solid #f5a623", objectFit: "cover" }}
                    onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                  />
                ) : null}
                <div style={{ width: "70px", height: "70px", borderRadius: "50%", background: "#f5a623", color: "black", display: hasPhoto ? "none" : "flex", alignItems: "center", justifyContent: "center", fontSize: "1.6rem", fontWeight: "700" }}>
                  {getInitials()}
                </div>
              </div>
              <div>
                <h2 style={{ fontSize: "1.2rem", marginBottom: "4px" }}>{displayName}</h2>
                <p style={{ fontSize: "0.85rem", color: "#6b7599", marginBottom: "4px" }}>{userData?.userID || "COD-XXXXXX"}</p>
                <p style={{ fontSize: "0.85rem", color: "#6b7599", marginBottom: "8px" }}>{user?.email}</p>
                <span className="id-badge id-badge-orange">Instructor</span>
              </div>
            </div>

            <div style={{ background: "#121a32", padding: "24px", borderRadius: "10px", display: "flex", flexDirection: "column", gap: "16px" }}>
              <h4 style={{ color: "white", fontSize: "1rem", fontWeight: "600" }}>Personal Information</h4>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Full Name</label>
                  <input className="id-input" placeholder="Your full name" defaultValue={displayName} />
                </div>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Phone Number</label>
                  <input className="id-input" placeholder="+91 XXXXX XXXXX" defaultValue={userData?.phone || ""} type="tel" />
                </div>
              </div>

              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Email Address</label>
                <input className="id-input" defaultValue={user?.email || ""} disabled style={{ opacity: 0.6 }} />
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Date of Birth</label>
                  <input className="id-input" type="date" />
                </div>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Gender</label>
                  <select className="id-input">
                    <option value="">Select gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                    <option>Prefer not to say</option>
                  </select>
                </div>
              </div>

              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Bio / About You</label>
                <textarea className="id-input id-textarea" placeholder="Tell students about yourself, your teaching style, background..." defaultValue={userData?.bio || ""} style={{ minHeight: "100px", resize: "vertical" }} />
              </div>

              <h4 style={{ color: "white", fontSize: "1rem", fontWeight: "600", marginTop: "8px" }}>Professional Information</h4>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Job Title</label>
                  <input className="id-input" placeholder="e.g. Senior Full Stack Developer" defaultValue={userData?.jobTitle || ""} />
                </div>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Company / Organization</label>
                  <input className="id-input" placeholder="e.g. Google, Infosys, Freelance" defaultValue={userData?.company || ""} />
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Years of Industry Experience</label>
                  <select className="id-input">
                    <option value="">Select experience</option>
                    <option>1-2 years</option>
                    <option>3-5 years</option>
                    <option>5-8 years</option>
                    <option>8-12 years</option>
                    <option>12+ years</option>
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Years of Teaching Experience</label>
                  <select className="id-input">
                    <option value="">Select experience</option>
                    <option>Less than 1 year</option>
                    <option>1-2 years</option>
                    <option>3-5 years</option>
                    <option>5+ years</option>
                  </select>
                </div>
              </div>

              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Areas of Expertise</label>
                <input className="id-input" placeholder="e.g. React, Node.js, Python, DevOps, Machine Learning..." defaultValue={userData?.expertise || ""} />
              </div>

              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Teaching Language(s)</label>
                <input className="id-input" placeholder="e.g. Hindi, English" defaultValue={userData?.languages || ""} />
              </div>

              <h4 style={{ color: "white", fontSize: "1rem", fontWeight: "600", marginTop: "8px" }}>Education & Certifications</h4>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Highest Qualification</label>
                  <select className="id-input">
                    <option value="">Select qualification</option>
                    <option>Diploma</option>
                    <option>Bachelor's Degree</option>
                    <option>Master's Degree</option>
                    <option>PhD</option>
                    <option>Self-taught / Bootcamp</option>
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>College / University</label>
                  <input className="id-input" placeholder="Your institution name" defaultValue={userData?.college || ""} />
                </div>
              </div>

              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Certifications</label>
                <input className="id-input" placeholder="e.g. AWS Certified, Google Cloud, Meta React Developer..." defaultValue={userData?.certifications || ""} />
              </div>

              <h4 style={{ color: "white", fontSize: "1rem", fontWeight: "600", marginTop: "8px" }}>Social & Online Presence</h4>

              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>LinkedIn URL</label>
                <input className="id-input" placeholder="https://linkedin.com/in/yourname" defaultValue={userData?.linkedin || ""} />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>GitHub URL</label>
                <input className="id-input" placeholder="https://github.com/yourname" defaultValue={userData?.github || ""} />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Portfolio / Personal Website</label>
                <input className="id-input" placeholder="https://yourwebsite.com" defaultValue={userData?.portfolio || ""} />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>YouTube Channel (if any)</label>
                <input className="id-input" placeholder="https://youtube.com/@yourchannel" defaultValue={userData?.youtube || ""} />
              </div>

              <button
                style={{ marginTop: "10px", background: "#f5a623", color: "black", border: "none", padding: "12px 24px", borderRadius: "8px", cursor: "pointer", fontWeight: "600", fontSize: "0.95rem", width: "fit-content" }}
              >
                Save Profile
              </button>
            </div>
          </div>
        );

      // ... [other cases unchanged]
      default:
        return null;
    }
  };

  return (
    <div className="id-layout">
      <aside className="id-sidebar">
        <h2 className="id-logo">CODE<span>ION</span></h2>
        <p className="id-role-tag">Instructor Portal</p>

        <nav className="id-nav">
          {menuItems.map((item) => (
            <button
              key={item.key}
              className={`id-nav-btn ${active === item.key ? "id-nav-active" : ""}`}
              onClick={() => setActive(item.key)}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="id-sidebar-footer">
          <p>{userData?.userID || user?.email}</p>
          <button className="id-logout-btn" onClick={logout}>Logout</button>
        </div>
      </aside>

      <main className="id-main">
        <div className="id-topbar">
          <div>
            <h2 className="id-page-title">
              {menuItems.find((m) => m.key === active)?.icon}{" "}
              {menuItems.find((m) => m.key === active)?.label}
            </h2>
          </div>

          <div className="id-user-profile" onClick={() => setOpenDropdown(!openDropdown)}>
            {hasPhoto ? (
              <img
                src={profilePhoto}
                alt="profile"
                className="id-profile-img-sm"
                referrerPolicy="no-referrer"
                onError={(e) => { e.target.style.display = "none"; }}
              />
            ) : (
              <div className="id-fallback-sm">{getInitials()}</div>
            )}
            <span>{displayName}</span>
            {openDropdown && (
              <div className="id-dropdown">
                <button onClick={() => { setActive("profile"); setOpenDropdown(false); }}>Profile</button>
                <button onClick={logout}>Logout</button>
              </div>
            )}
          </div>
        </div>

        <div className="id-body">{renderContent()}</div>
      </main>
    </div>
  );
}

export default InstructorDashboard;

